


const COLUMNS_designATION = [
  {
    id: "name",
    label: "Name",
    widget: "user",
    fixed:true
  }, {
    id: "head",
    label: "Head",
    widget: "profile"
  },
  {
    id: "createdBy",
    label: "Created By",
    widget: "profile"
  }, {
    id: "createdAt",
    label: "Created On",
    widget: "date"
  }];

const ROWS = [{
  id:'1',
  roleName:'roleName',
  permissionName:'permissionName',
  roleDescription:' simply dummy text of the printing and ',
  permissionDescription:' simply dummy text of the printing and ',
  randaomId: 'Kamal K',
  createdBy: 'Kamal K',
  designation: "Hr",
  mobile: "98766433456",
  email: "kamal@qubernet.com",
  description:`Lorem Ipsum is simply dummy text of the printing and Typesetting industry.` +
      `Lorem Ipsum has been the industry’s Standard dummy text ever since the 1500s,`  +
      ` when an unknown Printer took a gallery of type and scrambled it to make a type Specimen book.`+
      `It has survived not only five centuries, but also The leap into electronic typesetting`,
  status: "Active",
  roles: 'Paradot',
  groups:'human resources',
  lastSignedIn:'4557890',
  issueType:'bug',
  task:'Android Keyboard Document',
  comments:[{text:1},{text:2}],
  priority:2,
  members:[{name:'kamal', profilePic:'m1'},{name:'suku', profilePic:'m2'},{name:'john', profilePic:'m3'}]
}, {
  id:'2',
  randaomId: 'John',
  designation: "Hr",
  mobile: "98766433456",
  email: "kamal@qubernet.com",
  description:"Desc Text Desc TextDesc TextDesc Text Desc TextDesc TextDesc TextDesc TextDesc Text Desc TextDesc Text",
  status: "Inactive",
  roles: 'engineering',
  groups:'engineering',
  lastSignedIn:'4557890',
  issueType:'task',
  comments:[{text:1}],
  priority:4,
  task:'Android Keyboard Document',
  members:[{name:'kamal', profilePic:'m1'},{name:'suku', profilePic:'m2'},{name:'john', profilePic:'m3'}]
},{
  id:'3',
  randaomId: 'Musk',
  designation: "Hr",
  mobile: "98766433456",
  email: "kamal@qubernet.com",
  description:"Desc Text Desc TextDesc TextDesc Text Desc TextDesc TextDesc TextDesc TextDesc Text Desc TextDesc Text",
  status: "On Hold",
  roles: 'Devops',
  groups:'Devops',
  lastSignedIn:'4557890',
  issueType:'improvement',
  task:'Android Keyboard Document',
  priority:3,
  comments:[{text:1},{text:2}, {text:3}],
  members:[{name:'kamal', profilePic:'m1'},{name:'suku', profilePic:'m2'},{name:'john', profilePic:'m3'}]
},{
  id:'4',
  randaomId: 'Siva',
  designation: "Hr",
  mobile: "98766433456",
  email: "kamal@qubernet.com",
  description:"Desc Text Desc TextDesc TextDesc Text Desc TextDesc TextDesc TextDesc TextDesc Text Desc TextDesc Text",
  status: "In Review",
  roles: 'Finance',
  groups:'Finance',
  lastSignedIn:'4557890',
  issueType:'improvement',
  priority:1,
  task:'Android Keyboard Document',
  comments:[],
  members:[{name:'kamal', profilePic:'m1'},{name:'suku', profilePic:'m2'},{name:'john', profilePic:'m3'}]
},{
  id:'5',
  randaomId: 'Rajesh',
  designation: "Hr",
  mobile: "98766433456",
  email: "kamal@qubernet.com",
  description:"Desc Text Desc TextDesc TextDesc Text Desc TextDesc TextDesc TextDesc TextDesc Text Desc TextDesc Text",
  status: "Blocked",
  roles: 'Paradot',
  groups:'Marketing',
  lastSignedIn:'4557890',
  issueType:'improvement',
  priority:5,
  task:'Android Keyboard Document',
  comments:[],
  members:[]
},{
  id:'6',
  randaomId: 'Gokul',
  designation: "Hr",
  mobile: "98766433456",
  email: "kamal@qubernet.com",
  description:"Desc Text Desc TextDesc TextDesc Text Desc TextDesc TextDesc TextDesc TextDesc Text Desc TextDesc Text",
  status: "Duplicate",
  roles: 'Paradot',
  groups:'Pm team',
  lastSignedIn:'4557890',
  issueType:'improvement',
  priority:4,
  task:'Android Keyboard Document',
  comments:[{text:1},{text:2}, {text:3}],
  members:[]
},
{
  id:'7',
  randaomId: 'Kamal K',
  designation: "Hr",
  mobile: "98766433456",
  email: "kamal@qubernet.com",
  status: "Done",
  roles: 'Paradot',
  groups:'design',
  lastSignedIn:'4557890',
  issueType:'newFeature',
  task:'Android Keyboard Document',
  priority:5,
  comments:[],
  members:[]
},{
  id:'8',
  randaomId: 'Kamal K',
  designation: "Hr",
  mobile: "98766433456",
  email: "kamal@qubernet.com",
  status: "Completed",
  roles: 'Paradot',
  groups:'Development',
  lastSignedIn:'4557890',
  issueType:'newFeature',
  priority:1,
  task:'Android Keyboard Document',
  comments:[{text:1}],
  members:[]
}, {
  id:'9',
  randaomId: 'Hema K',
  designation: "Hr",
  mobile: "98766433456",
  email: "kamal@qubernet.com",
  status: "Reopen",
  roles: 'Paradot',
  groups:'Javascript',
  lastSignedIn:'4557890',
  issueType:'query',
  priority:5,
  task:'Android Keyboard Document',
  members:[],
  comments:[{text:1},{text:2}, {text:3}]
},{
  id:'19',
  randaomId: 'Hema K',
  designation: "Hr",
  mobile: "98766433456",
  email: "kamal@qubernet.com",
  status: "Reopen",
  roles: 'Paradot',
  groups:'Javascript',
  lastSignedIn:'4557890',
  issueType:'query',
  priority:5,
  task:'Android Keyboard Document',
  members:[],
  comments:[{text:1},{text:2}, {text:3}]
},{
  id:'29',
  randaomId: 'Hema K',
  designation: "Hr",
  mobile: "98766433456",
  email: "kamal@qubernet.com",
  status: "Reopen",
  roles: 'Paradot',
  groups:'Javascript',
  lastSignedIn:'4557890',
  issueType:'query',
  priority:5,
  task:'Android Keyboard Document',
  members:[],
  comments:[{text:1},{text:2}, {text:3}]
},{
  id:'39',
  randaomId: 'Hema K',
  designation: "Hr",
  mobile: "98766433456",
  email: "kamal@qubernet.com",
  status: "Reopen",
  roles: 'Paradot',
  groups:'Javascript',
  lastSignedIn:'4557890',
  issueType:'query',
  priority:5,
  task:'Android Keyboard Document',
  members:[],
  comments:[{text:1},{text:2}, {text:3}]
},{
  id:'49',
  randaomId: 'Hema K',
  designation: "Hr",
  mobile: "98766433456",
  email: "kamal@qubernet.com",
  status: "Reopen",
  roles: 'Paradot',
  groups:'Javascript',
  lastSignedIn:'4557890',
  issueType:'query',
  priority:5,
  task:'Android Keyboard Document',
  members:[],
  comments:[{text:1},{text:2}, {text:3}]
},{
  id:'59',
  randaomId: 'Hema K',
  designation: "Hr",
  mobile: "98766433456",
  email: "kamal@qubernet.com",
  status: "Open",
  roles: 'Paradot',
  groups:'Javascript',
  lastSignedIn:'4557890',
  issueType:'query',
  priority:5,
  task:'Android Keyboard Document',
  members:[],
  comments:[{text:1},{text:2}, {text:3}]
},{
  id:'69',
  randaomId: 'Hema K',
  designation: "Hr",
  mobile: "98766433456",
  email: "kamal@qubernet.com",
  status: "Todo",
  roles: 'Paradot',
  groups:'Javascript',
  lastSignedIn:'4557890',
  issueType:'query',
  priority:5,
  task:'Android Keyboard Document',
  members:[],
  comments:[{text:1},{text:2}, {text:3}]
}];
  
export {
  COLUMNS_designATION, ROWS
};